// extracted by mini-css-extract-plugin
export default {"Container":"RuleBlock_Container__R2X5o","Label":"RuleBlock_Label__jx7rA","Content":"RuleBlock_Content__BNIMM"};